export default __webpack_public_path__ + "static/media/btnUp.e4b66db8.svg";